module.exports = __webpack_public_path__ + "media/react/pages/answer_reviews/score_report/assets/banner_and_stars-770c564b886f0d118be51f4ae783c46c.svg";